import { render } from "./facility-photo.vue?vue&type=template&id=586ef28d&scoped=true"
import script from "./facility-photo.vue?vue&type=script&lang=js"
export * from "./facility-photo.vue?vue&type=script&lang=js"

import "./facility-photo.vue?vue&type=style&index=0&id=586ef28d&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-586ef28d"]])

export default __exports__